import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Star, Quote } from "lucide-react";

export default function ReviewsSection() {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    api.get("/reviews?limit=4").then((r) => setReviews(r.data)).catch(() => {});
  }, []);

  if (reviews.length === 0) return null;

  return (
    <section className="border-t border-white/5 bg-gradient-to-b from-transparent to-[var(--cl-surface)]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20">
        <div className="text-center mb-12">
          <div className="text-label text-[var(--cl-orange)]">Loved by rippers</div>
          <h2 className="font-display text-4xl sm:text-5xl mt-2">What Collectors Say</h2>
          <div className="flex justify-center items-center gap-1 mt-3 text-[var(--cl-gold)]">
            {[1,2,3,4,5].map((n) => <Star key={n} size={16} fill="currentColor" />)}
            <span className="text-zinc-400 text-sm ml-2">Real reviews from real collectors</span>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5" data-testid="reviews-grid">
          {reviews.map((r) => (
            <article key={r.id} data-testid={`review-${r.id}`}
                     className="relative border border-white/10 rounded-md bg-black/40 p-6 card-hover flex flex-col">
              <Quote size={18} className="absolute top-4 right-4 text-[var(--cl-primary)]/40" />
              <div className="flex items-center gap-1 text-[var(--cl-gold)] mb-3">
                {Array.from({length: r.rating || 5}).map((_, i) => <Star key={i} size={12} fill="currentColor" />)}
              </div>
              {r.title && <h3 className="font-display text-xl leading-tight mb-2">{r.title}</h3>}
              <p className="text-sm text-zinc-300 leading-relaxed flex-1">"{r.body}"</p>
              <div className="mt-5 pt-4 border-t border-white/5 flex items-center gap-3">
                {r.avatar_url ? (
                  <img src={r.avatar_url} alt={r.name} className="w-9 h-9 rounded-full object-cover ring-1 ring-white/10" />
                ) : (
                  <div className="w-9 h-9 rounded-full bg-[var(--cl-primary)]/20 text-[var(--cl-primary)] flex items-center justify-center font-display">
                    {r.name?.[0]?.toUpperCase() || "?"}
                  </div>
                )}
                <div className="min-w-0">
                  <div className="text-sm font-medium truncate">{r.name}</div>
                  {r.location && <div className="text-xs text-zinc-500 truncate">{r.location}</div>}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
